var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-header-tab col-md-6"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n        " + _vm._s(tab.value) + "\n        "), (tab.value == 'Client KYC') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Other Information') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Contracts') ? _c('span', {
      attrs: {
        "id": "third"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "right",
      "padding": "10px 27px 0px 0px"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showCreateServiceArea
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "title": "Go To Client List"
    }
  })])])]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "clientonboardform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Company Short/Display Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyname),
      expression: "companyname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientonboardform.CompanyName')
    },
    attrs: {
      "id": "CompanyName",
      "name": "CompanyName",
      "type": "text",
      "placeholder": "Enter Company Name",
      "disabled": _vm.clientEditDisable == true
    },
    domProps: {
      "value": (_vm.companyname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientonboardform.CompanyName')),
      expression: "errors.has('clientonboardform.CompanyName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Company Short/Display Name field is required")])], 1), _vm._v(" "), (_vm.showsavebutton == true) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-top": "28px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createNewClient
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client System ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientsystemid),
      expression: "clientsystemid"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ClientSystemID",
      "name": "ClientSystemID",
      "type": "text",
      "placeholder": "Enter Client System ID",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.clientsystemid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientsystemid = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientstatus),
      expression: "clientstatus"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ClientStatus",
      "name": "ClientStatus",
      "type": "text",
      "placeholder": "Enter Client Status",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.clientstatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientstatus = $event.target.value
      }
    }
  })])], 1)])], 1), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    tag: "component",
    staticClass: "tab",
    attrs: {
      "title": _vm.clientShortNameData,
      "clientData": _vm.clientData,
      "productlist": _vm.productlist,
      "statelist": _vm.statelist,
      "selectedEditRowData": _vm.selectedEditRowData
    },
    on: {
      "goBackToParent": _vm.showCreateServiceArea,
      "goBackToParent1": _vm.changeTab,
      "goBackToParent2": _vm.goToThirdTab
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248ec522","hasScoped":true}!./src/modules/clientmanagement/views/client/addclient/addclient.component.html
// module id = 687
// module chunks = 3